var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "apple",
    clipPath: "url(#clip0_3038_1136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2099"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 269",
    d: "M10.5906 0C9.67532 0.06331 8.60548 0.64919 7.98208 1.41212C7.41335 2.10423 6.94552 3.1322 7.12794 4.13119C8.12799 4.16231 9.16134 3.56248 9.7601 2.78668C10.3202 2.06453 10.7441 1.043 10.5906 1e-05V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 2102",
    clipPath: "url(#clip1_3038_1136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2101",
    clipPath: "url(#clip2_3038_1136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 270",
    d: "M13.9234 6.04808C13.0352 4.93438 11.7871 4.28809 10.6083 4.28809C8.59668 4.33121 8.47215 4.9982 7.39099 4.9982C6.27622 4.9982 5.65432 4.28809 4.30856 4.28809C2.94238 4.30191 1.67481 5.1254 0.778204 6.52806C-0.476466 8.47347 -0.261746 12.1312 1.77151 15.2467C2.49915 16.3615 3.37923 17.5645 4.65015 17.5753C5.78119 17.5861 5.85872 16.8594 7.39099 16.8519C8.92326 16.8432 9.15196 17.5873 10.2808 17.5753C11.5528 17.5656 12.5776 16.1764 13.3053 15.0617C13.8268 14.2625 14.021 13.8601 14.4254 12.9579C11.4834 11.8377 11.0117 7.65409 13.9234 6.04808H13.9234Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3038_1136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4254,
    height: 17.5754,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3038_1136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4254,
    height: 13.2874,
    fill: "white",
    transform: "translate(0 4.28809)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3038_1136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4254,
    height: 13.2874,
    fill: "white",
    transform: "translate(0 4.28809)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.ff8a6d9ebda61c558e927ee1366a5203.svg";
export { ForwardRef as ReactComponent };